export default "__VITE_ASSET__DSKwOS_R__"